import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function UsagePage() {
    return (_jsxs("div", { className: "page", children: [_jsxs("header", { className: "page-header", children: [_jsx("h2", { children: "Usage" }), _jsx("p", { className: "page-subtitle", children: "Bandwidth and request statistics" })] }), _jsx("div", { className: "placeholder-card", children: _jsx("p", { children: "Usage charts and analytics coming soon." }) })] }));
}
